import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { IndentWrapper } from '@yme/components/Separator';
import { getTestRideCategoryId } from '@yme/components/TestRide/redux/selectors';
import { usePrevious } from '@yme/hooks/usePrevious';
import { getBloomreachModel, getIsInAuthor, getNavigationBreadCrumbs } from '@yme/selectors/common';
import { PixelPageView, setPixelPageView } from '@yme/utils/bloomreach';
import { TestRideGridComponent } from '../TestRideGridComponent';
import { TEST_RIDE_CLP_TEST_ID } from '../constants';
export function TestRideClpGrid(props) {
    const { isRemoveBottomIndent, hyperdriveEndpoints, isShowDriverLicenseFilter, isInEditor, googleApiKey, } = props;
    const categoryId = useSelector(getTestRideCategoryId);
    const navigationBreadCrumbs = useSelector(getNavigationBreadCrumbs);
    const { productCatalog } = useSelector(getBloomreachModel);
    const isInAuthor = useSelector(getIsInAuthor);
    const prevCatId = usePrevious(categoryId);
    useEffect(() => {
        if (!isEmpty(categoryId) &&
            !isEmpty(navigationBreadCrumbs) &&
            prevCatId !== categoryId &&
            !isInAuthor) {
            setPixelPageView(PixelPageView.CATEGORY, {
                cat_id: categoryId || '',
                cat: navigationBreadCrumbs.join('|'),
                domain_key: productCatalog,
            });
        }
    }, [categoryId, isInAuthor, navigationBreadCrumbs, prevCatId, productCatalog]);
    if (!props || !hyperdriveEndpoints) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent, dataTestId: TEST_RIDE_CLP_TEST_ID },
        React.createElement(TestRideGridComponent, { googleApiKey: googleApiKey, isInEditor: isInEditor, hyperdriveEndpoints: hyperdriveEndpoints, isShowDriverLicenseFilter: isShowDriverLicenseFilter })));
}
TestRideClpGrid.displayName = 'TestRideClpGrid_AEMComponent';
